import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import SideMenu from '../../components/SideMenu';
import MobileSideMenu from '../../components/MobileSideMenu';
import TopBar from '../../components/TopBar';
import { STORAGE_TOKEN } from '../../constants';
import { SidebarDrawer } from '../../components/common';
import SubscriptionAlert from '../../components/settings/Subscription/SubscriptionAlert';

interface DashboardLayoutProps {}

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  const token = sessionStorage.getItem(STORAGE_TOKEN);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(false);
  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
   const [showAlert, setShowAlert] = React.useState(false)
   const [isExpired, setIsExpired] = React.useState(false)

let expired = false;
let limitReached = false

if(expired){
  setShowAlert(true)
  setIsExpired(true)
}
if(limitReached) {
  setShowAlert(true)
  setIsExpired(false)
}

  if (!token) {
    return <Navigate to="/auth" />;
  }

  return (
    <div className="max-w-screen min-h-screen">
      <div className="flex max-w-screen h-screen">
        <SideMenu collapsed={isSidebarCollapsed} />
        
        <div className={`w-${isSidebarCollapsed ? 'full' : 'full'} bg-[#E3EFFC] border overflow-x-hidden`}>
          <TopBar onSidebarToggle={handleSidebarToggle} />
          <div className="mt-[16px] px-4 md:px-[50px]">
            <Outlet />
          </div>
        </div>
      </div>

       <SidebarDrawer title='' position='left' show={showAlert}>
          <SubscriptionAlert isExpired={isExpired}/>
       </SidebarDrawer>

     </div>
  );
};

export default DashboardLayout;
